import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './TextField.css';

class HybridInput extends Component {
  static get propTypes() {
    return {
      inputProps: PropTypes.object,
      inputPropsNative: PropTypes.object,
      defaultValue: PropTypes.string
    };
  }

  componentWillReceiveProps(nextProps) {
    const { defaultValue } = this.props;
    const nextDefaultValue = nextProps.defaultValue;
    const nextInputProps = nextProps.inputProps;

    if (!nextInputProps.disabled && nextDefaultValue && (defaultValue !== nextDefaultValue
      || !nextInputProps.value)) {
      const mockEvent = {
        target: {
          value: nextProps.inputProps.value
        }
      };
      nextProps.inputPropsNative.onChange(mockEvent);
      nextProps.inputPropsNative.onBlur();
    }
  }

  componentDidMount() {
    const { inputProps } = this.props;
    if (inputProps.value === undefined) {
      return;
    }
    this.prePopulateInitialInputText();
  }

  render() {
    const { inputProps, inputPropsNative } = this.props;


    return (
      <div className="Select-input is-hybrid">
        <input {...inputPropsNative} {...inputProps} />
      </div>
    );
  }

  prePopulateInitialInputText() {
    const { inputProps, inputPropsNative } = this.props;
    const mockEvent = {
      target: {
        value: inputProps.value
      }
    };

    inputPropsNative.onChange(mockEvent);
    inputPropsNative.onBlur();
  }
}

export default HybridInput;



// WEBPACK FOOTER //
// ./src/recordDetail/fields/HybridInput.js